import { useCallback } from 'react';

import { GiftCardCheckoutFormReturn } from '../../gift-card-checkout-form.types';

// ─────────────────────────────────────────────────────────────────────────────

export const useGiftCardCheckoutFormState = (props: UseGiftCardCheckoutFormStateProps) => {
  const { form, submitForm } = props;

  const { amount, recipientName } = form.watch();
  const { isSubmitting, errors } = form.formState;
  const errorKeys = Object.keys(errors);
  const canSubmit = Boolean(recipientName) && errorKeys.length === 0;

  const requestFormSubmission = useCallback(
    (paymentMethodId: string) => {
      form.setValue('paymentMethodId', paymentMethodId);
      return submitForm();
    },
    [form, submitForm],
  );

  return {
    amount,
    isSubmitting,
    canSubmit,
    requestFormSubmission,
  };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type UseGiftCardCheckoutFormStateProps = {
  form: GiftCardCheckoutFormReturn;
  submitForm: () => Promise<void>;
};
